import { render, staticRenderFns } from "./AddDocumentVersion.vue?vue&type=template&id=5da13a19&"
import script from "./AddDocumentVersion.vue?vue&type=script&lang=js&"
export * from "./AddDocumentVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports